<!--  -->
<template>
  <div style="height:90%;overflow:auto;display:flex;justify-content:flex-start;">
  <el-button type="primary" icon="el-icon-arrow-left" style="height:50px" @click="toBack">返回</el-button>
  <el-form ref="form" :rules="rules" :model="data" label-width="100px">
      <el-form-item style="display:none">
      <el-input v-model="data.id" clearable></el-input>
      </el-form-item>
      <el-form-item label="背景图:" prop="backImg" style="text-align:center">
        <s-upload-img :getImageUrl="getBackImg" :url="data.backImg"></s-upload-img>
      </el-form-item>
      <el-form-item label="资讯标题:" prop="title">
      <el-input v-model="data.title" clearable></el-input>
      </el-form-item>
      <el-form-item label="背景颜色:" prop="title">
        <el-color-picker v-model="data.backgroundColor"></el-color-picker>
      </el-form-item>
      <el-form-item label="资讯内容:" prop="html">
        <WangEditor :getHtml="getHtml" :insertHtml="data.html" style="width:1500px;z-index: 1000;"></WangEditor>   
      </el-form-item>
      <el-form-item label="是否展示" label-width="120px">
            <el-switch
              v-model="data.ifshow"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
      </el-form-item>
      <div style="text-align:center">
      <el-button style="margin-left:100px;margin-bottom: 15px;" type="primary" @click="submit('form')" >{{(data.id==""||data.id==undefined)?'添加资讯信息':'更新资讯信息'}}</el-button>
      </div>
    </el-form>  
  </div>
</template>

<script>
import WangEditor from '@/components/WangEditor'
import sUploadImg from '@/components/SingleImgUpload'
import {insert,query,update} from '@/api/admin/brandInformation.js'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
//import引入的组件需要注入到对象中才能使用
components: {WangEditor,sUploadImg},
data() {
//这里存放数据
return {
  data:{
    id:"",
    backImg:"",
    title:"",
    html:"",
    ifshow:false,
    backgroundColor:"#000000"
  },
  rules:{
    backImg:{required:true,message:"背景图不能为空",trigger:'blur'},
    title:{required:true,message:"标题不能为空",trigger:'blur'},
    html:{required:true,message:"内容不能为空",trigger:'blur'}
  }
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
  data:{
    handler(newColor){
      console.log("data",newColor.backgroundColor)
      console.log("document",document)
      document.getElementsByClassName("w-e-scroll")[0].style.backgroundColor=newColor.backgroundColor
    },
    deep:true
  }

},
//方法集合
methods: {
  toBack(){
    setTimeout(()=>{
     this.$router.push("/admin/brandInformationList")
    },300)
  },
  getBackImg(img){
    this.data.backImg=img;
  },
  getHtml(h){
    this.data.html = h;
  },
  submit(name){
    var _this = this
    this.$refs[name].validate((vali)=>{
      if(vali){
        if(!(_this.data.id!=null&&_this.data.id!=""&&_this.data.id!=undefined)){
          insert(_this.data).then(()=>{
              this.$message.success("添加成功")
              this.$router.push({name:"abrandInformationList"})
          })
        }else{
          update(_this.data).then(()=>{
              this.$message.success("更新成功")
              this.$router.push({name:"abrandInformationList"})
          })
        }

      }else{
       this.$message.info("请填写完整信息")
      }

    })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  var _this = this
  if(this.$route.params.id!=null&&this.$route.params.id!=undefined&&this.$route.params.id!==""){
    query({id:_this.$route.params.id}).then(({data})=>{
      _this.data.id=data.id
      _this.data.backImg=data.backImg
      _this.data.title=data.title
      _this.data.html=data.html
      _this.data.ifshow=data.ifshow
      _this.data.backgroundColor=data.backgroundColor
    })
  }
  
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
// .bytemd{//修改编辑器的高度
//   height: 800px !important;
// }

</style>